import { Box } from "@chakra-ui/react";
import { ApexOptions } from "apexcharts";
import React from "react";
import ReactApexChart from "react-apexcharts";

// 
interface MyChartProps{
  series:{ name: string; data: number[]; }[];
  ops: object;
}
// const ops: ApexOptions = {
//   chart: {
//     type: "line",
//     id: "line-chart",
//     toolbar: {
//       show: false,
//     },
//   },
//   colors: ["#189B62", "#0066FF", "#9747FF"],
//   labels: ["Opens", "Clicks", "CTOR"],
//   noData: {
//     text: "No data available yet",
//     align: "center",
//     verticalAlign: "middle",
//     offsetX: 0,
//     offsetY: -18,
//     style: {
//       color: "#13161D",
//       fontSize: "20px",
//     },
//   },
//   stroke: {
//     curve: "smooth",
//   },
//   legend: {
//     show: true,
//     position: "top",
//     horizontalAlign: "right",
//     showForSingleSeries: false,
//     showForNullSeries: true,
//     showForZeroSeries: true,
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   fill: {
//     colors: ["#189B62", "#0066FF", "#9747FF"],
//   },
//   grid: {
//     show: true,
//     position: "front",
//     borderColor: "rgba(0, 102, 255, 0.12)",
//     xaxis: {
//       lines: {
//         show: true,
//       },
//     },
//     yaxis: {
//       lines: {
//         show: false,
//       },
//     },
//     row: {
//       colors: undefined,
//       opacity: 0.5,
//     },
//     column: {
//       colors: undefined,
//       opacity: 0.5,
//     },
//     padding: {
//       top: 0,
//       right: 0,
//       bottom: 0,
//       left: 0,
//     },
//   },
//   xaxis: {
//     categories: [
//       "3/6/24",
//       "7/6/24",
//       "11/6/24",
//       "15/6/24",
//       "19/6/24",
//       "25/6/24",
//       "29/6/24",
//     ],
//   },
//   yaxis: {
//     min: 0,
//     max: 200,
//   },

//   responsive: [
//     {
//       breakpoint: 480,
//       options: {
//         chart: {
//           width: 100,
//         },
//         legend: {
//           position: "bottom",
//         },
//       },
//     },
//   ],
// };


export function ApexLineChart({series,ops}:MyChartProps) {
  const [lineSeries, setLineSeries] = React.useState(series);
  const [lineChartOptions] = React.useState(ops);
  const [isEmpty, setIsEmpty] = React.useState(false);
  return (
    <Box w={"100%"} boxSizing="border-box" pt={6} pb={5} px={8}>
      <Box w="100%">
        <ReactApexChart
          height={400}
          options={lineChartOptions}
          series={series}
          type="line"
        />
      </Box>
    </Box>
  );
}
